/**
 * SPF cart-drawer sign-in nudge — dismissal persistence + handler.
 *
 * Loaded always (not inside the morphed cart markup) so it runs once on page
 * load regardless of cart state. The cart drawer re-renders via morphing, which
 * does NOT execute injected <script>s — so the dismiss state is carried on a
 * <html> class (+ CSS hide rule) and the click handler is document-delegated
 * once here. Both survive any number of cart re-renders.
 */
(function () {
  function applyHide() {
    try {
      if (localStorage.getItem('spfHideSigninNudge') === '1') {
        document.documentElement.classList.add('spf-hide-signin-nudge');
      }
    } catch (e) {}
  }

  applyHide();

  document.addEventListener('click', function (e) {
    // Dismiss ✕
    if (e.target.closest('[data-spf-signin-dismiss]')) {
      e.preventDefault();
      document.documentElement.classList.add('spf-hide-signin-nudge');
      try { localStorage.setItem('spfHideSigninNudge', '1'); } catch (e2) {}
      return;
    }
    // "Sign in to save your favourites" link -> native account sheet (not full page)
    var link = e.target.closest('.spf-signin-nudge__link');
    if (link && typeof window.spfOpenSignin === 'function') {
      e.preventDefault();
      window.spfOpenSignin(link.getAttribute('href'));
    }
  });
})();
